// This file doesn't import `nodes/registry`, so node types can import it without an import cycle.

/** Validation messages */
export const MSG_REQUIRED = 'This field must have a value';
export const MSG_INVALID_VALUE = 'Invalid value';
export const MSG_INVALID_VARIABLE = 'Contains an invalid variable reference';
